<template>
  <BOverlay
    id="scroll"
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      ref="tableContainer"
      class="overflow-y-auto h-[50vh]"
    >
      <BTable
        :items="items"
        :fields="fields"
        responsive
        show-empty
        class="zero-padding-td-b-table bordered-body-b-table"
        @row-clicked="goToDetail"
      >
        <template #empty>
          <div
            class="col-span-3 flex flex-col gap-[.75rem] items-center text-center py-[5rem]"
          >
            <div class="inline-block aspect-ratio--1x1 rounded-lg bg-[#F5F5F5] p-[.5rem] mx-auto">
              <feather-icon
                icon="ListIcon"
                size="20"
              />
            </div>
            <p class="m-0 font-medium text-xl text-black">
              Belum Ada Data Request
            </p>
            <p class="m-0 w-[300px]">
              Data churn request akan muncul disini.
            </p>
          </div>
        </template>

        <!-- Partner & ID -->
        <template #cell(partner_info)="data">
          <div class="px-[1rem] py-[.75rem]">
            <div class="font-semibold text-[14px] text-black">
              {{ data.item.partner ? data.item.partner.name : data.item.partner_name }}
            </div>
            <div class="text-[#A3A3A3] text-[12px] mt-[2px]">
              {{ data.item.partner ? data.item.partner.no_partner : data.item.partner_id }}
            </div>
          </div>
        </template>

        <!-- Talent Info -->
        <template #cell(talent_info)="data">
          <div class="px-[1rem] py-[.75rem]">
            <div class="font-semibold text-[14px] text-black">
              {{ data.item.talent ? data.item.talent.name : data.item.talent_name }}
            </div>
            <div class="text-[#A3A3A3] text-[12px] mt-[2px]">
              {{ data.item.talent ? data.item.talent.skill_name : data.item.talent_role }}
            </div>
            <div class="text-[#A3A3A3] text-[12px]">
              Lead: {{ data.item.talent ? data.item.talent.talent_lead_name : data.item.talent_lead }}
            </div>
          </div>
        </template>

        <!-- Tipe -->
        <template #cell(tipe)="data">
          <div class="px-[1rem] py-[.75rem] d-flex justify-content-center">
            <span
              class="badge-tipe"
              :class="getTipeBadgeClass(data.item.request_type.code)"
            >{{ data.item.request_type.name }}</span>
          </div>
        </template>

        <!-- Status Invoice -->
        <template #cell(status_invoice)="data">
          <div class="px-[1rem] py-[.75rem] d-flex justify-content-center">
            <span
              class="badge-status-invoice"
              :class="getInvoiceBadgeClass(data.item.invoice_status)"
            >{{ getInvoiceLabel(data.item.invoice_status) }}</span>
          </div>
        </template>

        <!-- Status Request -->
        <template #cell(status_request)="data">
          <div class="px-[1rem] py-[.75rem] d-flex justify-content-center">
            <span
              class="badge-status-request"
              :class="getRequestBadgeClass(data.item)"
            >
              <span class="badge-dot" />
              {{ data.item.status.name }}
            </span>
          </div>
        </template>
      </BTable>
      <div
        ref="scrollSentinel"
        class="sentinel h-2"
      />
    </div>
  </BOverlay>
</template>

<style scoped>
::v-deep tbody tr:hover {
  background-color: #E5E5E58A;
  cursor: pointer;
}

::v-deep .zero-padding-td-b-table td {
  padding: 0 !important;
}

::v-deep .bordered-body-b-table tbody {
  box-shadow:
    inset 0 -1px 0 #ddd,
    inset 1px 0 0 #ddd,
    inset -1px 0 0 #ddd;
  border-radius: 0 0 15px 15px;
}
</style>

<script>
import {
  tableFields,
  TYPE_MAP,
  INVOICE_MAP,
  REQUEST_MAP,
} from './config'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: tableFields,
    }
  },
  methods: {
    goToDetail(item) {
      if (item && item.id) {
        this.$router.push(`/churn-request/detail/${item.id}`)
      }
    },
    // ── Badge helpers ──────────────────────────
    getTipeBadgeClass(tipe) {
      const key = String(tipe || '').toUpperCase()
      return (TYPE_MAP[key] && TYPE_MAP[key].style) || 'badge-tipe--off'
    },
    getInvoiceBadgeClass(status) {
      const s = String(status || '').toUpperCase()
      return (INVOICE_MAP[s] && INVOICE_MAP[s].style) || 'badge-invoice--belum'
    },
    getInvoiceLabel(status) {
      const s = String(status || '').toUpperCase()
      return (INVOICE_MAP[s] && INVOICE_MAP[s].label) || status
    },
    getRequestBadgeClass({ status, invoice_status: invoiceStatus }) {
      let code = String(status.code || '').toUpperCase()
      if (code === 'IN_PROGRESS' && invoiceStatus === 'UNPAID') code = 'WAITING_PAYMENT'
      return (REQUEST_MAP[code] && REQUEST_MAP[code].style) || 'badge-request--progress'
    },
  },
}
</script>

<style scoped>
/* ── Tipe badges ────────────────────────── */
.badge-tipe {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
}

/* ── Status Invoice badges ──────────────── */
.badge-status-invoice {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
}

/* ── Status Request badges ──────────────── */
.badge-status-request {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  white-space: nowrap;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.badge-tipe--switch,
.badge-request--progress,
.badge-request--menunggu {
  background: #FFF7C2;
  color: #AB6400;
}

.badge-tipe--off,
.badge-invoice--belum {
  background: #F5F5F5;
  color: #737373;
}

.badge-tipe--ganti {
  background: #FFEFD6;
  color: #F76B15;
}

.badge-invoice--lunas,
.badge-request--selesai {
  background: #D6F1DF;
  color: #30A46C;
}

.badge-invoice--unpaid,
.badge-request--dibatalkan {
  background: #FEEBEC;
  color: #E5484D;
}

.badge-request--selesai .badge-dot {
  background: #30A46C;
}

.badge-request--dibatalkan .badge-dot {
  background: #E5484D;
}

.badge-request--progress .badge-dot,
.badge-request--menunggu .badge-dot {
  background: #FFC53D;
}
</style>
